import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';


class ClientDataSearchSheet extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number
    }

    constructor(props) {
        super(props);
        const { auth } = props;
        this.icons = [{ icon: '\ue659', order: 0 }];
        if ((auth === undefined || auth['histogramBrokenLine'] !== false)) {
            this.icons.push({ icon: '\ue652', order: 1 });
        }
        this.state = {
            current: 0,
            searchParams: {},
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    render() {
        const { businessList, clientHeight } = this.context;
        const { current, searchParams } = this.state;
        const { auth } = this.props;
        return (
            <div className="pane-item">
                <HeaderBar
                    title="客户数据查询"
                    //onChange={this.handleIconChange}
                    current={current}
                    //icons={this.icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        businessList={businessList}
                        onChange={this.handleChange}
                    />
                }
            </div>
        );
    }
}

export default ClientDataSearchSheet;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ClientDataSearch/ClientDataSearchSheet/index.js